import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as imagesApi from "@api/images.api";
import type { Image, ImageStats } from "@/types";

interface ImagesState {
  items: Image[];
  stats: ImageStats | null;
  loading: boolean;
}

const initialState: ImagesState = {
  items: [],
  stats: null,
  loading: false,
};

export const fetchImages = createAsyncThunk(
  "images/fetchAll",
  async (params?: { search?: string; sort?: string }) => {
    return await imagesApi.list(params);
  },
);

export const fetchStats = createAsyncThunk("images/fetchStats", async () => {
  return await imagesApi.getStats();
});

const imagesSlice = createSlice({
  name: "images",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchImages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchImages.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchImages.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.stats = action.payload;
      });
  },
});

export default imagesSlice.reducer;
